import { Link } from 'react-router-dom';
import { brand } from '../engine/catalog';
import { adsConfig } from '../config';

export function PrivacyPage() {
  return (
    <div className="container prose" style={{ paddingTop: 32 }}>
      <h1 style={{ fontSize: 32 }}>Privacy policy</h1>
      <p className="muted">Template — review with a qualified advisor before production use. Last updated: see repository history.</p>

      <h2>Your videos and voice recordings</h2>
      <ul>
        <li>Videos you open are read and processed <strong>entirely inside your browser</strong> (in a Web Worker on your device).</li>
        <li>{brand.name} does <strong>not</strong> upload your video, audio, speech analysis, edits or exported files to any server.</li>
        <li>Exported files are created in your browser's memory and saved only where you choose to download or share them.</li>
        <li>No account is required. We do not collect names, emails or contact lists through the editor.</li>
      </ul>

      <h2>Data stored on your device</h2>
      <ul>
        <li>Your theme choice and any custom voice presets you save are stored in your browser's local storage on this device. Clearing site data removes them.</li>
        <li>Nothing is stored about the content of your videos.</li>
      </ul>

      <h2 id="ads">Advertising</h2>
      <p>
        {adsConfig.enabled
          ? 'This site shows ads from Google AdSense on content pages and below a finished export (never while you edit or export).'
          : 'Advertising is currently disabled on this deployment.'}{' '}
        When ads are enabled, Google and its partners may use cookies or similar technologies to serve and measure ads,
        and — depending on your region and choices — to personalise them. Google's use of advertising data is described at{' '}
        <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noreferrer">How Google uses information from sites that use its services</a>.
        Where required (for example in the EEA, UK and Switzerland), a consent message from a Google-certified consent
        management platform is shown before personalised ads are used, and you can change your choice at any time through the
        “Privacy choices” link in the footer.
      </p>
      <p>Ads never receive your video, audio, transcripts or editing history: media processing does not touch the network.</p>

      <h2>Network requests</h2>
      <ul>
        <li>Loading the website (HTML, JavaScript, CSS) from the hosting provider.</li>
        <li>When ads are enabled: requests to Google ad services on pages that show ads.</li>
        <li>
          Only if you press “Find filler words with speech recognition”: a one-time download of speech-model files
          (about 42 MB) from Hugging Face (huggingface.co), cached by your browser. Your audio is processed on your
          device and is not sent anywhere.
        </li>
        <li>No analytics or crash-reporting services are included.</li>
      </ul>

      <h2>Children</h2>
      <p>The service is not directed at children under 13 (or the age required in your country).</p>

      <h2>Contact</h2>
      <p>Questions: <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a></p>
    </div>
  );
}

export function TermsPage() {
  return (
    <div className="container prose" style={{ paddingTop: 32 }}>
      <h1 style={{ fontSize: 32 }}>Terms of use</h1>
      <p className="muted">Template — review with a qualified advisor before production use.</p>
      <h2>Using {brand.name}</h2>
      <ul>
        <li>You may use the editor for lawful purposes on media you own or have permission to edit.</li>
        <li>Do not use voice effects to impersonate real people, deceive others, or harass anyone.</li>
        <li>The Tapori and other character presets are stylized sound effects. They are not intended to mock any community.</li>
      </ul>
      <h2>No warranty</h2>
      <p>
        The service is provided “as is”. Noise reduction, filler detection and pause detection are automatic estimates and can
        make mistakes; always review your result before publishing. Keep a copy of your original video — {brand.name} never
        modifies it, but you are responsible for your own backups.
      </p>
      <h2>Limits</h2>
      <p>Browser processing depends on your device's memory and the codecs your browser supports. Very long videos may not process in a browser.</p>
    </div>
  );
}

export function ContactPage() {
  return (
    <div className="container prose" style={{ paddingTop: 32 }}>
      <h1 style={{ fontSize: 32 }}>Contact & support</h1>
      <p>Email: <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a></p>
      <h2>Before you write</h2>
      <ul>
        <li><strong>Export fails or the tab crashes:</strong> try a shorter clip, close other tabs, or use a recent Chrome, Edge or Firefox.</li>
        <li><strong>“Cannot decode audio”:</strong> your browser does not support that audio codec. Converting the video to MP4 (H.264 + AAC) usually helps.</li>
        <li><strong>Cuts re-encode the video:</strong> this is expected — frame-accurate cuts cannot be made by copying compressed video.</li>
      </ul>
      <p>Please do not email private videos. We never need your media to help you.</p>
      <p><Link to="/editor" className="btn btn--primary">Back to the editor</Link></p>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="container" style={{ paddingTop: 48 }}>
      <h1>Page not found</h1>
      <p><Link to="/">Go to the home page</Link></p>
    </div>
  );
}
